import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";
import { getGradeAPI } from "../../../assignmentAPI";

import { boldText } from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";

const KorBlankPage = ({
  currentPage,
  currentIndex,
  setCurrentIndex,
  userInput,
  selectedBlankIndex,
  setUserInput,
  setSelectedBlankIndex,
  pageList,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.data.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          // isSubmitted가 false이면 input을, true이면 firstAttemptAnswer를 보여줌
          if (currentPage.isSubmitted && question.firstAttemptAnswer) {
            setUserInput(question.firstAttemptAnswer);
          } else {
            setUserInput(question.input);
          }
        }
      }
    });
  };

  const handleSubmit = async () => {
    if (currentPage.isSubmitted) return;

    if (userInput === "") return alert("답을 입력해주세요.");

    const response = await getGradeAPI({
      data: {
        eng: currentPage.data.eng,
        input: userInput,
        answer: currentPage.data.answer,
      },
      type: "kor_blank",
    });
    const isCorrect = response.is_correct === 1;

    const data = {
      ...currentPage.data,
      question: currentPage.data.question.map((element) => {
        if (element.type === "blank") {
          const isFirstAttempt = element.firstAttemptCorrect === undefined;
          
          if (isCorrect)
            return {
              ...element,
              isSubmitted: true,
              input: userInput,
              isCorrect: isCorrect,
              firstAttemptCorrect: isFirstAttempt ? isCorrect : element.firstAttemptCorrect,
              firstAttemptAnswer: isFirstAttempt ? userInput : element.firstAttemptAnswer,
            };
          else {
            return {
              ...element,
              isSubmitted: true,
              input: currentPage.data.answer,
              isCorrect: isCorrect,
              firstAttemptCorrect: isFirstAttempt ? isCorrect : element.firstAttemptCorrect,
              firstAttemptAnswer: isFirstAttempt ? userInput : element.firstAttemptAnswer,
            };
          }
        }
        return element;
      }),
    };

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: data,
          isSubmitted: true,
          isCorrect: isCorrect,
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    setSelectedBlankIndex(-1);
    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.data.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "blank") {
                if (element.index === selectedBlankIndex) {
                  return { ...element, input: userInput };
                }
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      <div style={{ fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px", fontWeight: 700, textAlign: "center" }}>빈칸을 채우세요.</div>
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "17px" : "28px",
          textAlign: "center", // [v8] 문장 가운데
        }}
      >
        {currentPage.type !== "" &&
          currentPage.data.question.map((element, index) => {
            if (element.type === "text") {
              return element.content;
            } else if (element.type === "blank") {
              const userAnswer = element.input;
              const blankLength = element.length;
              const isSelected = element.index === selectedBlankIndex;

              return (
                <span
                  key={"kor_blank_" + index}
                  onClick={() => changeSelectedBlank(element)}
                  style={{
                    display: "inline-block",
                    minWidth: 20,
                    marginRight: 4,
                    marginLeft: 4,
                    padding: "0 4px",
                    cursor: "pointer",
                    letterSpacing: userAnswer === "" ? "0" : null,
                    // ECHO 시안 13 — 활성 빈칸: teal 밑줄 + teal-mist / 그 외: ink-25 밑줄
                    borderBottom: isSelected
                      ? "1.5px solid #00D9C0"
                      : "1.5px solid #B9C1C9",
                    borderRadius: "6px 6px 0 0",
                    backgroundColor: isSelected ? "#F2FAF8" : "transparent",
                  }}
                >
                  {userAnswer || "\u00A0".repeat(blankLength)}
                </span>
              );
            }
            return null;
          })}
      </div>
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "13px" : "20px", // [문장테스트 v5] 해석 축소
          color: "#7A8490",
        }}
      >
        {boldText({ text: currentPage.data.kor || currentPage.data.eng })}
      </div>
      <div style={{ position: "relative", width: Math.min(window.innerWidth, window.screen.width) <= 768 ? "92%" : "60%", marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "22px" : "50px", marginBottom: Math.min(window.innerWidth, window.screen.width) <= 768 ? "48px" : 0 }}>
        <UserInputBar
          handleSetAnswer={handleSubmit}
          handleChange={handleChange}
          userInput={
            currentPage.isSubmitted && selectedBlankIndex >= 0
              ? currentPage.data.question.find(q => q.type === "blank" && q.index === selectedBlankIndex)?.firstAttemptAnswer || userInput
              : userInput
          }
          disabled={currentPage.isSubmitted}
          type={"analysis"}
        />
      </div>
      <button
        style={{
          // [제출 인라인] 모바일은 흐름 속 배치(둥둥 제거), PC는 기존 위치
          position: Math.min(window.innerWidth, window.screen.width) <= 768 ? "static" : "absolute",
          alignSelf: Math.min(window.innerWidth, window.screen.width) <= 768 ? "flex-end" : undefined,
          marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : 0,
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 22px" : "10px 32px", // [제출 v2]
          backgroundColor: currentPage.isSubmitted ? "#E6EDEC" : "#0E141B", // ECHO cur-submit
          color: currentPage.isSubmitted === true ? "#7A8490" : "white",
          border: "none",
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "16px",
          fontWeight: 700,
          borderRadius: "999px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default KorBlankPage;
